import {EnumInfo, EnumInfoMap, FileType} from "../../declarations/index";
import {PaymentPlanFrequency} from "../../enums";

export const FileTypeMap: EnumInfoMap<FileType> = new Map<FileType, EnumInfo>([
  ["unknown", {labelKey: "Unknown"}],
  ["dispute", {labelKey: "Dispute"}],
  ["phone_call_recording", {labelKey: "Phone Call Recording"}],
  ["phone_call_transcription", {labelKey: "Phone Call Transcription"}],
  ["incoming_email_attachment", {labelKey: "Incoming Email Attachment"}],
  ["cease_and_desist_notice", {labelKey: "C&D Notice"}],
  ["bankruptcy", {labelKey: "Bankruptcy"}],
  ["account_statement", {labelKey: "Account Statement"}],
  ["contract", {labelKey: "Contract"}],
  ["borrower_membership_agreement", {labelKey: "Borrower Membership Agreement"}],
  ["transaction_history", {labelKey: "Transaction History"}],
  ["redacted_assignment", {labelKey: "Redacted Assignment"}],
  ["terms_and_conditions", {labelKey: "Terms and Conditions"}],
  ["consent_form", {labelKey: "Consent Form"}],
  ["representation_notice", {labelKey: "Representation Notice"}],
  ["bank_statement", {labelKey: "Bank Statement"}],
  ["cure_notice", {labelKey: "Cure Notice"}],
  ["general", {labelKey: "General"}],
  ["lawsuit", {labelKey: "Lawsuit"}],
  ["complaint", {labelKey: "Complaint"}],
]);

export const getEnumLabelKey = <T>(map: EnumInfoMap<T>, value?: T): string => {
  if (!value) {
    return "notAvailable";
  }
  return map.get(value)?.labelKey || "notAvailable";
};

export const paymentPlanFrequencyInfoMap: EnumInfoMap<PaymentPlanFrequency> = new Map<PaymentPlanFrequency, EnumInfo>([
  ["weekly", {labelKey: "Weekly"}],
  ["bi_weekly", {labelKey: "Bi-weekly"}],
  ["monthly", {labelKey: "Monthly"}],
  ["one_time", {labelKey: "One Time"}],
  ["first_and_fifteenth", {labelKey: "1st & 15th"}],
  ["non_linear", {labelKey: "Custom"}],
  ["last_business_day_of_the_month", {labelKey: "Last bus. day of the month"}],
]);
